module.exports = __webpack_public_path__ + "static/media/WEB10.943719fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB10.png
// module id = 85
// module chunks = 0